__turbopack_context__.v({
  "alert": "Alert-module__dfj2kq__alert",
  "content": "Alert-module__dfj2kq__content",
  "error": "Alert-module__dfj2kq__error",
  "errorIcon": "Alert-module__dfj2kq__errorIcon",
  "icon": "Alert-module__dfj2kq__icon",
  "information": "Alert-module__dfj2kq__information",
  "informationIcon": "Alert-module__dfj2kq__informationIcon",
  "success": "Alert-module__dfj2kq__success",
  "successIcon": "Alert-module__dfj2kq__successIcon",
  "textWrapper": "Alert-module__dfj2kq__textWrapper",
  "warning": "Alert-module__dfj2kq__warning",
  "warningIcon": "Alert-module__dfj2kq__warningIcon",
  "withButton": "Alert-module__dfj2kq__withButton",
});
